import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { AuthCallbackComponent } from './components/auth/auth-callback/auth-callback.component';
import { SingleSignOnComponent } from './components/single-sign-on/single-sign-on.component';
import { V1SingleSignOnComponent } from './components/v1-single-sign-on/v1-single-sign-on.component';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';

@NgModule({
  declarations: [AuthCallbackComponent, SingleSignOnComponent, V1SingleSignOnComponent],
  exports: [AuthCallbackComponent, SingleSignOnComponent, V1SingleSignOnComponent],
  imports: [
    NgbModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PipesModule,
    LoadingModule,
    TranslateModule,
  ],
})
export class UserModule {}
